const Index = () => import(/* webpackChunkName: "manager" */ './Index');
const Personal = () => import(/* webpackChunkName: "personal" */ './Personal');

export default {
  routes: [
    {
      path: '/coop/index',
      name: 'coop_index',
      component: Index
    },
    {
      path: '/coop/personal',
      name: 'coop_personal',
      component: Personal
    }
  ]
}
